/* eslint-disable */
import vuetify from 'vuetify';
import zhHant from 'vuetify/es5/locale/zh-Hant'
import 'vuetify/dist/vuetify.min.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import XLSX from 'xlsx';
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
// import 'element-ui/lib/theme-chalk/display.css';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

import '@/assets/css/custom.css';

// import '@/assets/css/main.css';
import '@/lib/math_uuid';
import VueSignaturePad from 'vue-signature-pad';
import VueI18n from 'vue-i18n';

import Vue from 'vue';
import store from './store';
import App from './App';
import router from './router';

import locales from './assets/i18n';

Vue.use(VueSignaturePad);
Vue.use(VueI18n);
Vue.use(XLSX);
// Vue.use(ElementUI);
Vue.use(vuetify, {
  lang: {
    locales: { zhHant },
    current: 'zhHant'
  }
});
Vue.config.productionTip = false;

Vue.config.lang = localStorage.inn_lang || 'tw';
Object.keys(locales).forEach((lang) => {
  Vue.locale(lang, locales[lang]);
});
/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   store,
//   router,
//   components: { App },
//   template: '<App/>',
// });

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js